import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { SelfThemerService } from '../lib-services/self-themer.service';
import { ResponsiveImage } from '../models/responsive-image';

@Component({
  selector: 'lib-img',
  templateUrl: './image.component.html',
  styleUrls: ['./image.component.scss']
})
export class ImageComponent implements OnInit, OnChanges {

  constructor(public themerSvc: SelfThemerService) { }
  @Input() src: string;
  @Input() ext: string;
  @Input() alt: string;
  @Input() responsive: ResponsiveImage;

  ngOnInit(): void {
  }
  ngOnChanges(changes: SimpleChanges): void {
    // let fileSeperator = this.src.lastIndexOf('/');
    // console.log(fileSeperator);
    // console.log(this.src.substring(0,fileSeperator))
    // console.log(this.src.substring(fileSeperator))
    if(this.themerSvc.theme){

    }
    else{
      throw new Error("Theme has not been initialized properly")
    }
  }

}
